import Axios from '../axios-instance';

const EmployeesApi = {
    get : (supplierId) => {
        return Axios.post('/Employees/Get', supplierId).then(({ data }) => data);
    },

    disassociate : (supplierId) => {
        return Axios.post('/Employees/disassociate', supplierId).then(({ data }) => data);
    },

    newEmployee: body => {
        return Axios.post('/Employees/create', body).then(({ data }) => data);
      },
    getManagement: body => {
        return Axios.post('/Employees/GetManagement', body).then(({ data }) => data);
    },
    disableEmployee: body => {
        return Axios.post('/Employees/DisableEmployee', body).then(({ data }) => data);
    },
    enableEmployee: body => {
        return Axios.post('/Employees/EnableEmployee', body).then(({ data }) => data);
    },
    exportToExcel: body => {
        return Axios.post('/Employees/exportToExcel', body , { responseType: "arraybuffer"}).then(({ data }) => data);
    }
}

export default EmployeesApi;